module.exports = __webpack_public_path__ + "img/37.a752a5b7.jpg";